import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=2aaad8cf&scoped=true"
import script from "./collect.vue?vue&type=script&lang=js"
export * from "./collect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaad8cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aaad8cf')) {
      api.createRecord('2aaad8cf', component.options)
    } else {
      api.reload('2aaad8cf', component.options)
    }
    module.hot.accept("./collect.vue?vue&type=template&id=2aaad8cf&scoped=true", function () {
      api.rerender('2aaad8cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/nfseDataCheck/cmp/collect.vue"
export default component.exports